import React from 'react'

const MemberListPageSchema = ({data, index }) => {
  return (
    <React.Fragment>
    <tr className={index % 2  ?  'text-gray-600 bg-gray-50' : 'bg-white'} key={data.id}>
      <td className='pl-4 pr-4 py-4 font-semibold' style={{width: '14%'}}>{data.name}</td>
      <td className='pl-5 pr-4 py-4 justify-center' style={{width: '11%'}}> {data.employee_id ?? 'NA'} </td>
      <td className='pl-5 pr-4 py-4 justify-center' style={{width: '11%'}}> {data.email} </td>
      <td className='pl-5 pr-4 py-4 justify-center' style={{width: '11%'}}> {data.created_at} </td>
    </tr>
  </React.Fragment>
  )
}

export default MemberListPageSchema